import type { SearchResponse } from '~/types/search';

interface CombinedSearchResults extends Pick<SearchResponse, 'hits'>, Partial<Pick<SearchResponse, 'totalHits' | 'skip' | 'take'>> {
  hasNextPage: boolean;
}

export function combineSearchResults(
  agentResponse: SearchResponse | null,
  pagination: SearchResponse | null,
  useFallback: boolean
): CombinedSearchResults {
  const hits = [...(agentResponse?.hits ?? []), ...(pagination?.hits ?? [])];
  const totalHits = useFallback ? pagination?.totalHits : agentResponse?.totalHits;
  const skip = pagination?.skip ?? agentResponse?.skip;
  const take = pagination?.take ?? agentResponse?.take;
  const hasNextPage = totalHits ? totalHits > hits.length : false;

  return { hits, totalHits, skip, take, hasNextPage };
}
